"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MessageCircleBlank: function() {
        return MessageCircleBlank;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const MessageCircleBlank = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C7.02945 3 3.00002 7.02944 3.00002 12C3.00002 13.4751 3.35415 14.8647 3.98114 16.091C4.08378 16.2917 4.11557 16.5212 4.07136 16.7423L3.27477 20.7252L7.2577 19.9287C7.47879 19.8844 7.70832 19.9162 7.90906 20.0189C9.13535 20.6459 10.5249 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1.00002 12C1.00002 5.92487 5.92488 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C10.3273 23 8.73941 22.626 7.31765 21.9563L2.19613 22.9806C1.86827 23.0462 1.52933 22.9435 1.29291 22.7071C1.05649 22.4707 0.953864 22.1317 1.01944 21.8039L2.04374 16.6824C1.37404 15.2606 1.00002 13.6727 1.00002 12Z",
        fill: "currentColor"
    })
}), "MessageCircleBlank");
const _default = MessageCircleBlank;
